import React from 'react';
import { Link } from "react-router-dom";
import './providerReview.css';

const ProviderReview = ({ 
    provider_name,
    provider_ratings,
    provider_mobile,
    rating_all_together,
    is_pro_user,
    is_insurance_verified,
    insured,
    provider_id,
    project_id,
    provider_avatar,
    provider_project_id,
    is_reviewed,
    years_of_experience 
}) => {
    return (
        <>
            <div className="provider-card">
                <h2 className="provider-heading">Provider Details</h2>
                <div className="provider-footer">
                    <div className="provider-profile">
                        <img 
                            src={provider_avatar || "/assets/images/New-files/default-card-img-a.png"} 
                            className="provider-avatar" 
                            alt="Provider Avatar"
                        />
                        <div className="provider-details">
                            <div className="provider-name-wrapper">
                                <span className="provider-name">{provider_name}</span>
                                {is_pro_user && <span className="pro-badge">Pro +</span>}
                            </div>
                            <div className="rating-container">
                                <div className="rating-score">
                                    <span>{rating_all_together?.rating_all_together}</span>
                                    <img src="/assets/images/New-files/ionic-ios-star.png" alt="Star" />
                                </div>
                                <div className="rating-count">
                                    {rating_all_together?.reviews_all_together} ratings
                                </div>
                                <div className="experience-years">
                                    {years_of_experience}+ years
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!is_reviewed && (
                <Link to={`/feedback/${project_id}/${provider_project_id}/${provider_id}`}>
                    <div className="review-prompt">
                        <img 
                            src="/assets/images/New-files/review-thumb-icon.svg" 
                            alt="Review" 
                            className="review-icon" 
                        />
                        <p className="review-title">Leave a review for you provider</p>
                        <div className="review-cta">
                            <span>Review</span>
                            <img 
                                src="/assets/icon/next.png" 
                                alt="Next" 
                                className="next-icon" 
                            />
                        </div>
                    </div>
                </Link>
            )}
        </>
    );
};

export default ProviderReview;